import { useFormik } from 'formik';
import React, { useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

const AddShipline = ({ show, handleClose, token, user_id, refresh }) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    let initialValues = {
        name: "",
        scac: "",
        bic: "",
        alias: "",
        is_nvocc: false
    };


    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/master/shipline/add`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Shipline</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <InputTextJSX
                                labelText={"Shipline Name"}
                                nameValue={"name"}
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                maxLength={100}
                            />
                            <InputTextJSX
                                labelText={"SCAC"}
                                nameValue={"scac"}
                                value={formik.values.scac}
                                onChange={formik.handleChange}
                                maxLength={10}
                            />
                            <InputTextJSX
                                labelText={"BIC"}
                                nameValue={"bic"}
                                value={formik.values.bic}
                                onChange={formik.handleChange}
                                maxLength={10}

                            />
                            <InputTextJSX
                                labelText={"Alias"}
                                nameValue={"alias"}
                                value={formik.values.alias}
                                onChange={formik.handleChange}
                                maxLength={10}

                            />


                            <div className={`col-md-6 mt-2 d-flex align-items-center`}>
                                <div className='ms-2'>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input
                                            type="checkbox"
                                            className="me-2"
                                            id="is_nvocc"
                                            name="is_nvocc"
                                            checked={formik.values.is_nvocc}
                                            onChange={(e) => {
                                                formik.setFieldValue("is_nvocc", e.target.checked);
                                            }}
                                        />
                                        <label htmlFor="" className='form-label  mb-0'>
                                            NVOCC
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="row d-flex justify-content-end mt-2">
                                <div className="col-md-6 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                        {
                                            disableSubmit ?
                                                <>
                                                    <i className="fas fa-spinner fa-spin"></i> Saving...
                                                </>
                                                :
                                                "Add"
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddShipline